import React from "react";
import styles from "../styles/vinos.module.css";

export default function VinoModal({
    open,
    editing,
    formData,
    setFormData,
    onClose,
    onSubmit,
}) {
    if (!open) return null;

    return (
        <div className={styles["modal-overlay"]}>
            <div className={`${styles["modal-content"]} ${styles["modal-form"]}`}>
                <form onSubmit={onSubmit}>
                    <h3>{editing ? "Editar vino" : "Nuevo vino"}</h3>

                    <div className={styles["grid-2"]}>
                        <div className={styles.field}>
                            <label className={styles.label}>Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={(e) => setFormData((p) => ({ ...p, nombre: e.target.value }))}
                                placeholder="Nombre del vino"
                                required
                            />
                        </div>

                        <div className={styles.field}>
                            <label className={styles.label}>Tipo</label>
                            <input
                                type="text"
                                name="tipo"
                                value={formData.tipo}
                                onChange={(e) => setFormData((p) => ({ ...p, tipo: e.target.value }))}
                                placeholder="p.ej., Tinto, Blanco, Rosado…"
                                required
                            />
                        </div>
                    </div>

                    <div className={styles["grid-2"]}>
                        <div className={styles.field}>
                            <label className={styles.label}>Descripción</label>
                            <textarea
                                name="descripcion"
                                value={formData.descripcion}
                                onChange={(e) => setFormData((p) => ({ ...p, descripcion: e.target.value }))}
                                placeholder="Notas, bodega, añada, maridaje…"
                            />
                        </div>
                    </div>

                    <details className={styles.card} style={{ marginTop: 12 }}>
                        <summary style={{ cursor: "pointer" }}>Traducción (Inglés)</summary>

                        <div className={styles["grid-2"]} style={{ marginTop: 12 }}>
                            <div className={styles.field}>
                                <label className={styles.label}>Name (EN)</label>
                                <input
                                    type="text"
                                    name="nombre_en"
                                    value={formData.nombre_en}
                                    onChange={(e) => setFormData((p) => ({ ...p, nombre_en: e.target.value }))}
                                    placeholder="Wine name in English"
                                />
                            </div>

                            <div className={styles.field}>
                                <label className={styles.label}>Type (EN)</label>
                                <input
                                    type="text"
                                    name="tipo_en"
                                    value={formData.tipo_en}
                                    onChange={(e) => setFormData((p) => ({ ...p, tipo_en: e.target.value }))}
                                    placeholder="e.g., Red, White, Rosé…"
                                />
                            </div>
                        </div>

                        <div className={styles.field}>
                            <label className={styles.label}>Description (EN)</label>
                            <textarea
                                name="descripcion_en"
                                value={formData.descripcion_en}
                                onChange={(e) => setFormData((p) => ({ ...p, descripcion_en: e.target.value }))}
                                placeholder="Notes in English…"
                            />
                        </div>
                    </details>

                    <div className={styles["modal-actions"]}>
                        <button type="button" className={`${styles.btn} ${styles.ghost}`} onClick={onClose}>
                            Cancelar
                        </button>
                        <button type="submit" className={`${styles.btn} ${styles.primary}`}>
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
